import { Component, OnInit, Input, ElementRef, ViewChild, Output, NgZone } from '@angular/core';
import { DesignStudioService } from 'src/app/services/design-studio/design-studio.service';
import { EventEmitter } from '@angular/core';
import { CartService } from 'src/app/services/cart/cart.service';
import { Subscription } from 'rxjs';
import { Storage } from '@ionic/storage';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserService } from 'src/app/services/user/user.service';
import { ConsoleService } from 'src/app/services/console/console.service';
import { Router} from '@angular/router';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    // host: {
    //     '(document:click)': 'onClickDocument($event)',
    // },
})

export class PageHeaderComponent implements OnInit  {
    @Input() region: any;
    @Output() openRegionModalEvent = new EventEmitter();
    @Input() stickyHeader: boolean;
    @Output() getStickyHeight = new EventEmitter();

    @Input() backButton: boolean;
    @Input() innerPage: boolean;
    @Input() widgetPage: boolean;
    @Input() title: any;


    data = {};
    cartLength = 0;
    cartTotalPrice: number = 0;
    cartSub: Subscription;
    loginStatus = false;
    notificationbarBgColor;



    headerData:any;

    constructor(
        private designStudioService: DesignStudioService,
        private cartService: CartService,
        private storage: Storage,
        private configService: ConfigService,
        public userService: UserService,
        private consoleService:ConsoleService,
        private router: Router
    ) {
		this.data['priceForRetail'] = this.configService.environment.priceForRetail;
        this.data['currencyCode'] = this.configService.environment.currencyCode;
        this.data['RFQFeature'] = this.configService.environment.RFQFeature;
	 }

    async ngOnInit() {
        this.getStickyHeight.emit('150');
        this.headerData = await this.designStudioService.getSessionStorageHeaderData();

        //this.headerData.logoURL = "../../../assets/img/shop-logo-color.png";
        this.consoleService.consoleLog('app-page-header:56 headerdata',this.headerData);

        if(this.headerData.designStudioActive) {
       		this.setCssColor();
			// if (this.headerData.logo && this.headerData.logo.logoURL) {
			//     this.headerData.logoURL = this.headerData.logo.logoURL;
			//     console.log('header custom logo');
			// } else {
			//     this.headerData.logoURL = "../../../assets/img/shop-logo-color.png";
			//     console.log('header no custom logo');
			// }
        }

		/* this fixes the issue when sometimes the following code is executed before cart
		products are set in cartService */
        let cartProducts = this.cartService.getCartProducts();
		if (cartProducts.length == 0) {
			await this.cartService.setCartProducts();
        	cartProducts = this.cartService.getCartProducts();
		}
        console.log('cartProducts', cartProducts);
        this.data['cartLength'] = cartProducts.length;
        this.data['cartTotalPrice'] = this.cartService.getCartPrice(cartProducts);
        this.data['role'] = await this.storage.get('userRole');
        this.initializeSubscriptions();
    }

    setCssColor(){
        // if(this.headerData.notificationBar.color.backgroundColor.hex){
        //     notificationbarBgColor = this.headerData.notificationBar.color.backgroundColor.hex;
        // }
        // else{
        //     notificationbarBgColor = 'var(--ion-color-primary)';
        // }
        let logoCustomHeight = this.headerData.logo.customHeight;
        let logoWidth = this.headerData.logo.width;
        let logoHeight = this.headerData.logo.height;

        let headerBgColor;
        headerBgColor = this.headerData.color && this.headerData.color.backgroundColor && this.headerData.color.backgroundColor.hex ? this.headerData.color.backgroundColor.hex : 'var(--ion-color-primary)';

        let headerColor;
        headerColor = this.headerData.color && this.headerData.color.foregroundColor && this.headerData.color.foregroundColor.hex ? this.headerData.color.foregroundColor.hex : 'var(--ion-color-primary-contrast)';

        let notificationBgColor;
        notificationBgColor = this.headerData.notificationBar && this.headerData.notificationBar.color && this.headerData.notificationBar.color.backgroundColor && this.headerData.notificationBar.color.backgroundColor.hex ? this.headerData.notificationBar.color.backgroundColor.hex : '#FF5757';

        let notificationColor;
        notificationColor = this.headerData.notificationBar && this.headerData.notificationBar.color && this.headerData.notificationBar.color.foregroundColor && this.headerData.notificationBar.color.foregroundColor.hex ? this.headerData.notificationBar.color.foregroundColor.hex : '#fff';

        let infobarBgColor;
        infobarBgColor = this.headerData.infoBar && this.headerData.infoBar.color && this.headerData.infoBar.color.backgroundColor && this.headerData.infoBar.color.backgroundColor.hex ? this.headerData.infoBar.color.backgroundColor.hex : '#f6f9ff';

        let infobarColor;
        infobarColor = this.headerData.infoBar && this.headerData.infoBar.color && this.headerData.infoBar.color.foregroundColor && this.headerData.infoBar.color.foregroundColor.hex ? this.headerData.infoBar.color.foregroundColor.hex : '#111';

        let loginBtnBgColor;
        loginBtnBgColor = this.headerData.loginButton && this.headerData.loginButton.color && this.headerData.loginButton.color.backgroundColor && this.headerData.loginButton.color.backgroundColor.hex ? this.headerData.loginButton.color.backgroundColor.hex : 'var(--ion-color-primary)';

        let loginBtnColor;
        loginBtnColor = this.headerData.loginButton && this.headerData.loginButton.color && this.headerData.loginButton.color.foregroundColor && this.headerData.loginButton.color.foregroundColor.hex ? this.headerData.loginButton.color.foregroundColor.hex : 'var(--ion-color-primary-contrast)';

        let wishlistBtnBgColor;
        wishlistBtnBgColor = this.headerData.wishlistButton && this.headerData.wishlistButton.color && this.headerData.wishlistButton.color.backgroundColor && this.headerData.wishlistButton.color.backgroundColor.hex ? this.headerData.wishlistButton.color.backgroundColor.hex : 'var(--ion-color-primary)';

        let wishlistBtnColor;
        wishlistBtnColor = this.headerData.notificationBar && this.headerData.notificationBar.color && this.headerData.notificationBar.color.foregroundColor && this.headerData.notificationBar.color.foregroundColor.hex ? this.headerData.notificationBar.color.foregroundColor.hex : 'var(--ion-color-primary-contrast)';

        let cartBtnBgColor;
        cartBtnBgColor = this.headerData.cartButton && this.headerData.cartButton && this.headerData.cartButton.color.backgroundColor.hex && this.headerData.cartButton.color.backgroundColor.hex ? this.headerData.cartButton.color.backgroundColor.hex : 'var(--ion-color-primary)';

        let cartBtnColor;
        cartBtnColor = this.headerData.cartButton && this.headerData.cartButton.color && this.headerData.cartButton.color.foregroundColor && this.headerData.cartButton.color.foregroundColor.hex ? this.headerData.cartButton.color.foregroundColor.hex : 'var(--ion-color-primary-contrast)';

        let menuBgColor;
        menuBgColor = this.headerData.menuData && this.headerData.menuData.color && this.headerData.menuData.color.backgroundColor && this.headerData.menuData.color.backgroundColor.hex ? this.headerData.menuData.color.backgroundColor.hex : 'var(--ion-color-primary)';

        let menuColor;
        menuColor = this.headerData.menuData && this.headerData.menuData.color && this.headerData.menuData.color.foregroundColor && this.headerData.menuData.color.foregroundColor.hex ? this.headerData.menuData.color.foregroundColor.hex : 'var(--ion-color-primary-contrast)';





        const css = `:root {
            --header-bg-color: ${headerBgColor};
            --header-color: ${headerColor};
            --notificationbar-bg-color: ${notificationBgColor};
            --notificationbar-color: ${notificationColor};
            --infobar-bg-color: ${infobarBgColor};
            --infobar-color: ${infobarColor};
            --login-btn-bg-color: ${loginBtnBgColor};
            --login-btn-color: ${loginBtnColor};
            --wishlist-btn-bg-color: ${wishlistBtnBgColor};
            --wishlist-btn-color: ${wishlistBtnColor};
            --cart-btn-bg-color: ${cartBtnBgColor};
            --cart-btn-color: ${cartBtnColor};
            --menu-bg-color: ${menuBgColor};
            --menu-color: ${menuColor};
            --logo-width: ${logoWidth}px;
            --logo-height: ${logoHeight}px;

            --cart-btn-bg-color-red: ${this.headerData.cartButton.color.backgroundColor.rgb.r};
            --cart-btn-bg-color-green: ${this.headerData.cartButton.color.backgroundColor.rgb.g};
            --cart-btn-bg-color-blue: ${this.headerData.cartButton.color.backgroundColor.rgb.b};
            --cart-btn-color-rgb: (${this.headerData.cartButton.color.foregroundColor.rgb.r},${this.headerData.cartButton.color.foregroundColor.rgb.g},${this.headerData.cartButton.color.foregroundColor.rgb.b});
                            }`;
        const head = document.getElementsByTagName('head')[0];
        const style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(css));
        head.appendChild(style);
    }

    openSearchPage(){
        this.router.navigate(['search-items']);
    }

    ngOnDestroy() {
        this.removeSubscriptions();
    }

    async initializeSubscriptions() {
        this.cartSub = this.cartService.getCartProductsListener().subscribe((cartProducts) => {
            this.data['cartLength'] = cartProducts.length;
            this.data['cartTotalPrice'] = this.cartService.getCartPrice(cartProducts);
        });
    }

    setHeader() {
       // this.designStudioService.setHeaderData(this.dumyheaderData)
    }

    openRegionModal(type) {
        this.openRegionModalEvent.emit(type);
    }

    removeSubscriptions() {
        this.cartSub.unsubscribe();
    }
}